import * as Font from 'expo-font'
import { ReactElement, useEffect, useState } from 'react'
import { Fonts } from 'zens-storybook'

interface Props {
  children: ReactElement | null
}

const FontProvider = (props: Props) => {
  const { children } = props
  const [appIsReady, setAppIsReady] = useState(false)

  useEffect(() => {
    const load = async () => {
      try {
        await Font.loadAsync(Fonts)
        setAppIsReady(true)
      } catch (error) {
        console.debug('Fonts error: ', error)
      }
    }
    load()
  }, [])

  if (!appIsReady) return null

  return children
}

export default FontProvider
